"use client";

import React from "react";
import { Select, SelectItem } from "@/components/ui/simple-select";
import { ResponsiveCommandMultiSelect } from "@/components/ui/responsive-select/ResponsiveCommandMultiSelect";
import type { SimpleFieldConfig } from "../../../types/index";

interface SelectFilterInputProps {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  currentFilter?: { type: string; value: any };
  addAdvancedFilter: (fieldId: string, filterType: string, value: any) => void;
}

export function SelectFilterInput({
  fieldId,
  fieldConfig,
  currentFilter,
  addAdvancedFilter,
}: SelectFilterInputProps) {
  return (
    <div className="space-y-2">
      <Select
        value={currentFilter?.type || "exact"}
        onValueChange={(type) => {
          // When changing filter type, preserve current values if they exist
          let currentValues = [];

          if (currentFilter?.value) {
            if (Array.isArray(currentFilter.value)) {
              currentValues = currentFilter.value;
            } else if (currentFilter.value !== "all") {
              currentValues = [currentFilter.value];
            }
          }

          // For 'exact' type, we need to ensure it's an array for "Any of (OR)" functionality
          // For 'multiSelect' type, we already have an array
          addAdvancedFilter(fieldId, type, currentValues);
        }}
        className="w-full"
      >
        <SelectItem value="exact">Any of (OR)</SelectItem>
        <SelectItem value="multiSelect">Multiple values</SelectItem>
      </Select>

      {currentFilter?.type === "multiSelect" ? (
        <ResponsiveCommandMultiSelect
          value={Array.isArray(currentFilter?.value) ? currentFilter.value : []}
          onValueChange={(values) => addAdvancedFilter(fieldId, "multiSelect", values)}
          options={fieldConfig.options || []}
          placeholder={`Select ${fieldConfig.label}...`}
          className="w-full"
        />
      ) : (
        // For 'exact' type (Any of OR), we also use multi-select to allow multiple selections
        <ResponsiveCommandMultiSelect
          value={Array.isArray(currentFilter?.value) ? currentFilter.value : []}
          onValueChange={(values) => addAdvancedFilter(fieldId, "exact", values)}
          options={fieldConfig.options || []}
          placeholder={`Select ${fieldConfig.label}...`}
          className="w-full"
        />
      )}
    </div>
  );
}
